import { Typography } from 'antd'
import colors from 'helpers/colors'
import { urls } from 'helpers/urls'
import Link from 'next/link'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

type Props = {
  ownerId: string
  ownerName: string
}

export const OwnerNameSection: FC<Props> = ({ ownerId, ownerName }) => {
  const { t } = useTranslation()

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      <Typography.Text
        style={{ fontSize: '12px', lineHeight: 1.5, color: colors.grey30 }}
      >
        {t('主催')}
      </Typography.Text>
      <Link href={urls.owner(ownerId)}>
        <a
          style={{
            fontSize: '14px',
            lineHeight: 1.5,
            textDecoration: 'underline',
            fontWeight: 500,
            color: colors.grey65,
          }}
        >
          {ownerName}
        </a>
      </Link>
    </div>
  )
}
